import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "eximxpress_admin_token";

export const authApi = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clearToken: () => localStorage.removeItem(TOKEN_KEY),
  isAuthed: () => !!localStorage.getItem(TOKEN_KEY),
  authHeader: () => {
    const t = localStorage.getItem(TOKEN_KEY);
    return t ? { Authorization: `Bearer ${t}` } : {};
  },
  async login(email, password) {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    return data.user;
  },
  logout() {
    localStorage.removeItem(TOKEN_KEY);
  },
  async me() {
    const { data } = await axios.get(`${API}/auth/me`, { headers: this.authHeader() });
    return data;
  },
  async getQuotes() {
    const { data } = await axios.get(`${API}/admin/quotes`, { headers: this.authHeader() });
    return data;
  },
  async getContacts() {
    const { data } = await axios.get(`${API}/admin/contacts`, { headers: this.authHeader() });
    return data;
  },
};

export function formatApiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
